export const DEFAULT_MIN_VIEWPORT_WIDTH = 1024;
export const DEFAULT_MIN_MOBILE_VIEWPORT_WIDTH = 480;

export interface DeviceType {
	isMobile: boolean;
	isDesktop: boolean;
	isTablet?: boolean;
}